module.exports = __webpack_public_path__ + "static/media/ZikaLegend.3ab2587d.png";